export enum EditorPluginEnum {
  SKOLETUBE = 'skoletube',
  BORNETUBE = 'bornetube',
  YOUTUBE = 'youtube',
}
